module.exports = __webpack_public_path__ + "img/tab-stores-inactive.f059dbf1.svg";